export enum GameCategory {
  QUIZ = 'quiz',
  CHAT_QUIZ = 'chat_quiz',
  SEARCH_IMAGE = 'search_image'
}
